/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance } from "../utils/axiosInstance";
// import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const PersonalInfo = ({ setProfileData }) => {
  // const navigate = useNavigate();

  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: Yup.string()
      .matches(/^\d+$/, "Phone number must be numeric")
      .required("Phone number is required"),
    address: Yup.string().required("Address is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("first_name", values?.firstName);
        formData.append("last_name", values?.lastName);
        formData.append("email", values?.email);
        formData.append("address", values?.address);
        formData.append("phone", values?.phone);
        formData.append("image", "");
        const response = await axiosInstance.post(
          "user/profile/process",
          formData
        );
        if (response?.data?.status === true) {
          toast.success(response?.data?.message || "Profile Save..! ");
          getAllInfo();
        } else {
          toast.error(
            response?.data?.message || "Something went wrong, try again."
          );
        }
      } catch (error) {
        console.error("Error:", error);
        const errorMessage =
          error?.response?.data?.message || "An unexpected error occurred.";
        toast.error(errorMessage);
      }
    },
  });

  const getAllInfo = async () => {
    try {
      await axiosInstance.get("user/profile").then((response) => {
        if (response?.data?.status === true) {
          formik.setFieldValue("firstName", response?.data?.user?.first_name);
          formik.setFieldValue("lastName", response?.data?.user?.last_name);
          formik.setFieldValue("email", response?.data?.user?.email);
          formik.setFieldValue("phone", response?.data?.user?.phone);
          formik.setFieldValue("address", response?.data?.user?.address);
          setProfileData({ ...response?.data?.user });
        }
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    getAllInfo();
  }, []);

  return (
    <div className="dashboard_content">
      <div className="dashboard_body">
        <h3>Personal information</h3>
        <div className="dash_personal_info">
          <div className="dash_personal_info_edit comment_input p-0 mb_0">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="comment_imput_single">
                    <label>First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.firstName}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="error_message text-red">
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="comment_imput_single">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.lastName}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="error_message text-red">
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="comment_imput_single">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      readOnly
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="error_message text-red">
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="comment_imput_single">
                    <label>Phone</label>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="error_message text-red">
                        {formik.errors.phone}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="comment_imput_single">
                    <label>Address</label>
                    <textarea
                      name="address"
                      rows={4}
                      placeholder="Address"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <div className="error_message text-red">
                        {formik.errors.address}
                      </div>
                    ) : null}
                  </div>
                  <button type="submit" className="common_btn">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
